// extracted by mini-css-extract-plugin
var _1 = "Add_divider__Up8VK";
export { _1 as "divider" }
